import React from "react";
import "../../css/Services.css";
import MortgageImage from "../../assets/images/Home Page (2).jpg";
import ProtectionImage from "../../assets/images/Home Page (3).jpg";
import { useNavigate } from "react-router-dom";

function Services() {
  const navigate = useNavigate();
  return (
    <section className="services" id="mortgages">
      <div className="services-container">
        <h2>OUR SERVICES</h2>
        <div className="divider" />
        <div className="services-grid">
          <div className="service-card">
            <div className="service-image">
              <img src={MortgageImage} alt="Mortgage" />
            </div>
            <h3>MORTGAGES</h3>
            <p>
              Looking to purchase your first home, remortgage, move home or
              looking to build a buy-to-let portfolio, having the right advice
              in place can help you achieve your goals.
            </p>
            <button
              className="service-button"
              onClick={() => navigate("/mortgages")}
            >
              Find out More
            </button>
          </div>

          <div className="service-card" id="protection">
            <div className="service-image">
              <img src={ProtectionImage} alt="Protection" />
            </div>
            <h3>PROTECTION</h3>
            <p>
              Get some peace of mind by finding the right protection coverage
              for the most important things in your life.
            </p>
            <button
              className="service-button"
              onClick={() => navigate("/protection")}
            >
              Find out More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
